import React from "react";
import { Image } from "./image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";

export const GallerySlider = (props) => {
  return (
    <div id="portfolio" className="text-center py-10">
      <div className="section-title mb-8">
        <h2 className="text-3xl font-bold">Galería</h2>
      </div>
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        autoplay={{ delay: 2000 }}
        loop={true}
        spaceBetween={40}
        slidesPerView={3}
        breakpoints={{
          1024: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          480: { slidesPerView: 1 },
        }}
        className="swiper-container"
      >
        {props.data
          ? props.data.map((d, i) => (
              <SwiperSlide key={`${d.title}-${i}`}>
                <Image
                  title={d.title}
                  subtitle={d.subtitle}
                  largeImage={d.largeImage}
                  smallImage={d.smallImage}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "12px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  }}
                />
              </SwiperSlide>
            ))
          : "Loading..."}
      </Swiper>
    </div>
  );
};
